import { useAppSettings } from '../hooks/useAppSettings';

interface CoverImageProps {
  src: string | null | undefined;
  alt: string;
  className?: string;
  containerClassName?: string;
  loading?: 'lazy' | 'eager';
  fallback?: React.ReactNode;
}

export function CoverImage({
  src,
  alt,
  className = '',
  containerClassName = '',
  loading,
  fallback,
}: CoverImageProps) {
  const showCoverImages = useAppSettings((s) => s.showCoverImages);

  const shouldShowImage = showCoverImages && !!src;

  if (shouldShowImage) {
    return containerClassName ? (
      <div className={containerClassName}>
        <img src={src!} alt={alt} className={className} loading={loading} />
      </div>
    ) : (
      <img src={src!} alt={alt} className={className} loading={loading} />
    );
  }

  // Fallback: custom or default first-character circle
  if (fallback) {
    return <>{fallback}</>;
  }

  return (
    <div className={containerClassName || 'absolute inset-0 flex items-center justify-center'}>
      <div className="text-center p-4">
        <div className="w-16 h-16 mx-auto mb-3 rounded-full bg-primary-500 flex items-center justify-center">
          <span className="text-2xl text-white font-bold">
            {alt.charAt(0)}
          </span>
        </div>
        <p className="text-sm text-neutral-500 dark:text-neutral-400 line-clamp-2 font-medium">
          {alt}
        </p>
      </div>
    </div>
  );
}
